// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.championship-registration-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(2, 6, 23, 0.75);
  backdrop-filter: blur(4px);
}

.championship-registration-modal {
  width: min(560px, 100%);
  max-height: min(92vh, 760px);
  overflow: auto;
  border-radius: 20px;
  border: 1px solid var(--border, #334155);
  background: var(--surface, #0f172a);
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.45);
}

.championship-registration-modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 20px 24px 12px;
  border-bottom: 1px solid var(--border, #334155);
}

.championship-registration-modal-header h3 {
  margin: 0 0 4px;
  font-size: 1.1rem;
}

.championship-registration-modal-header p {
  margin: 0;
  color: var(--text-muted, #94a3b8);
}

.championship-registration-modal-body {
  padding: 20px 24px 24px;
}

.icon-button {
  border: 0;
  border-radius: 999px;
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  color: inherit;
  cursor: pointer;
}

.icon-button:hover {
  background: rgba(148, 163, 184, 0.16);
}
`, "",{"version":3,"sources":["webpack://./src/components/ChampionshipRegistrationModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,cAAc;EACd,mBAAmB;EACnB,wCAAwC;EACxC,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC","sourcesContent":[".championship-registration-modal-backdrop {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 1000;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 24px;\r\n  background: rgba(2, 6, 23, 0.75);\r\n  backdrop-filter: blur(4px);\r\n}\r\n\r\n.championship-registration-modal {\r\n  width: min(560px, 100%);\r\n  max-height: min(92vh, 760px);\r\n  overflow: auto;\r\n  border-radius: 20px;\r\n  border: 1px solid var(--border, #334155);\r\n  background: var(--surface, #0f172a);\r\n  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.45);\r\n}\r\n\r\n.championship-registration-modal-header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  padding: 20px 24px 12px;\r\n  border-bottom: 1px solid var(--border, #334155);\r\n}\r\n\r\n.championship-registration-modal-header h3 {\r\n  margin: 0 0 4px;\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.championship-registration-modal-header p {\r\n  margin: 0;\r\n  color: var(--text-muted, #94a3b8);\r\n}\r\n\r\n.championship-registration-modal-body {\r\n  padding: 20px 24px 24px;\r\n}\r\n\r\n.icon-button {\r\n  border: 0;\r\n  border-radius: 999px;\r\n  width: 36px;\r\n  height: 36px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: transparent;\r\n  color: inherit;\r\n  cursor: pointer;\r\n}\r\n\r\n.icon-button:hover {\r\n  background: rgba(148, 163, 184, 0.16);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
